<template>
    <v-dialog
        :value="value"
        @input="$emit('input', $event)"
        fullscreen
        persistent
        scrollable
    >
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn type="button" icon @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="p-5">
                <trix-vue
                    :initial-content="initContent"
                    :save-path="saveUrl"
                    :axiosConfig="axiosConfig"
                    @content-saved="$emit('saved')"
                ></trix-vue>
            </v-card-text>

            <v-divider></v-divider>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import TrixVue from '@dymantic/vue-trix-editor'

export default Vue.extend({
  components: {
    TrixVue
  },

  props: {
    value: Boolean,
    initContent: String,
    saveUrl: {
      type: String,
      required: true
    },
    axiosConfig: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {}
  }
})
</script>
